const getTabListStyle = ({
  direction,
  type,
  offset
}) => {
  if (direction === "vertical") {
    return { transform: `translateY(${-offset}px)` };
  }
  if (type === "capsule") {
    return { transform: `translateX(${offset}px)` };
  }
  return { transform: `translateX(${-offset}px)` };
};
export { getTabListStyle };
